import { useLocation, useNavigate } from "react-router-dom";
import { LOCALES, useLocale } from "@/i18n/LocaleContext";

/*
 Functional language switcher. Clicking a locale switches the URL prefix
 while preserving the current path and hash.
*/
export const LanguageSwitcher = ({ variant = "light" }) => {
  const { locale, pathWithoutLocale } = useLocale();
  const location = useLocation();
  const navigate = useNavigate();

  const activeColor = variant === "light" ? "text-cream" : "text-navy";
  const inactiveColor = variant === "light" ? "text-cream/55 hover:text-cream" : "text-navy/55 hover:text-navy";
  const rule = variant === "light" ? "bg-cream/25" : "bg-navy/20";
  const goldDot = "bg-gold";

  const switchTo = (target) => {
    if (target === locale) return;
    const suffix = pathWithoutLocale === "/" ? "" : pathWithoutLocale;
    navigate(`/${target}${suffix}${location.hash || ""}`);
  };

  return (
    <div
      data-testid="language-switcher"
      className="inline-flex items-center gap-3 font-sans text-[11px] font-medium"
      style={{ letterSpacing: "0.24em" }}
      aria-label="Language selector"
    >
      {LOCALES.map((l, i) => {
        const isActive = l === locale;
        const label = l.toUpperCase();
        return (
          <span key={l} className="inline-flex items-center gap-3">
            <button
              type="button"
              onClick={() => switchTo(l)}
              data-testid={`lang-${l}`}
              aria-current={isActive ? "page" : undefined}
              className={[
                "relative inline-flex flex-col items-center transition-colors duration-500 ease-out",
                isActive ? activeColor : inactiveColor,
              ].join(" ")}
            >
              <span>{label}</span>
              <span
                aria-hidden
                className={[
                  "mt-1 h-px w-full",
                  isActive ? goldDot : "bg-transparent",
                ].join(" ")}
              />
            </button>
            {i < LOCALES.length - 1 && <span className={`h-3 w-px ${rule}`} aria-hidden />}
          </span>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
